import Settings from "@/pages/Settings/Settings";
import Tolerances from "@/pages/Maintainers/ApplicationOrders/Tolerances/Tolerances";
import CustomerPage from "@/pages/Settings/Customer/CustomerPage";
import Integrations from "@/pages/Integrations/Integrations";
import MaintainersBusiness from "@/pages/Maintainers/Business/Business";
import MaintainersEstates from "@/pages/Maintainers/Estates/Estates";
import MaintainersOrderClassifications from "@/pages/Maintainers/OrderClassifications/OrderClassifications";
import MaintainersUsers from "@/pages/Maintainers/Users/Users";
import MaintainersOperators from "@/pages/Maintainers/Operators/Operators";
import MaintainersCategories from "@/pages/Maintainers/Categories/Categories";
import MaintainersSpecies from "@/pages/Maintainers/Species/Species";
import MaintainersVarieties from "@/pages/Maintainers/Varieties/Varieties";
import MaintainersQuarters from "@/pages/Maintainers/Quarters/Quarters";
import MaintainersBusinessCenter from "@/pages/Maintainers/BusinessCenter/BusinessCenter/BusinessCenter";
import MaintainersHauliers from "@/pages/Maintainers/Hauliers/Hauliers";
import MaintainersEstatesParents from "@/pages/Maintainers/EstatesParents/EstatesParents";
import MaintainersObjectives from "@/pages/Maintainers/ApplicationOrders/Objectives/Objectives";
import MaintainersMachineries from "@/pages/Maintainers/ApplicationOrders/Machinery/Machinery";
import MaintainersIrrigations from "@/pages/Maintainers/ApplicationOrders/Irrigations/Irrigations";
import MaintainersPhenologicalState from "@/pages/Maintainers/ApplicationOrders/PhenologicalState/PhenologicalState";
import OAType from "@/pages/Maintainers/ApplicationOrders/Type/OAType";
import SpecieVariety from "@/pages/Maintainers/BusinessCenter/SpecieVariety/SpecieVariety";
import DistributionLists from "@/pages/Maintainers/DistributionLists/DistributionLists";

const adminEstateRole = () => ["administrador", "gerente_agricola", "administrador_campo"];
const userRole = () => ["administrador", "gerente_agricola", "administrador_campo", "usuario"];

export const settingsRoutes = [
	{
		path: `/configuracion/integraciones/:option?/:element_id?`,
		Component: Integrations,
		roles: adminEstateRole(),
	},
	{
		path: `/configuracion/cliente`,
		Component: CustomerPage,
		roles: adminEstateRole(),
	},
	{
		path: `/configuracion/razones_sociales/:option?/:slug?`,
		Component: MaintainersBusiness,
		roles: userRole(),
	},
	{
		path: `/configuracion/campos/:option?/:slug?`,
		Component: MaintainersEstates,
		roles: userRole(),
	},
	{
		path: `/configuracion/maquinarias/:option?/:element_id?`,
		Component: MaintainersMachineries,
		roles: userRole(),
	},
	{
		path: `/configuracion/clasificaciones_oc/:option?/:classification_id?`,
		Component: MaintainersOrderClassifications,
		roles: userRole(),
	},
	{
		path: `/configuracion`,
		Component: Settings,
		roles: userRole(),
	},
	{
		path: `/configuracion/usuarios/:option?/:slug?`,
		Component: MaintainersUsers,
		roles: userRole(),
	},
	{
		path: `/configuracion/operadores/:option?/:slug?`,
		Component: MaintainersOperators,
		roles: userRole(),
	},
	{
		path: `/configuracion/tipo_orden_aplicacion/:option?/:element_id?`,
		Component: OAType,
		roles: userRole(),
	},
	{
		path: `/configuracion/estado_fenologico_oa/:option?/:element_id?`,
		Component: MaintainersPhenologicalState,
		roles: userRole(),
	},
	{
		path: `/configuracion/objetivos_oa/:option?/:element_id?`,
		Component: MaintainersObjectives,
		roles: userRole(),
	},
	{
		path: `/configuracion/riegos/:option?/:irrigation_id?`,
		Component: MaintainersIrrigations,
		roles: userRole(),
	},
	{
		path: `/configuracion/categorias/:option?/:slug?`,
		Component: MaintainersCategories,
		roles: userRole(),
	},
	{
		path: `/configuracion/paso-1/:option?/:slug?`,
		Component: MaintainersSpecies,
		roles: userRole(),
	},
	{
		path: `/configuracion/paso-2/:option?/:slug?`,
		Component: MaintainersVarieties,
		roles: userRole(),
	},
	{
		path: `/configuracion/paso-3/:option?/:slug?`,
		Component: MaintainersQuarters,
		roles: userRole(),
	},
	{
		path: `/configuracion/centro_costo/:option?/:slug?`,
		Component: MaintainersBusinessCenter,
		roles: userRole(),
	},
	{
		path: `/configuracion/transportistas/:option?/:slug?`,
		Component: MaintainersHauliers,
		roles: userRole(),
	},
	{
		path: `/configuracion/grupos_campos/:option?/:slug?`,
		Component: MaintainersEstatesParents,
		roles: userRole(),
	},
	{
		path: `/configuracion/especies_variedades/:option?/:element_id?`,
		Component: SpecieVariety,
		roles: userRole(),
	},
	{
		path: `/configuracion/listas_difusion/:option?/:element_id?`,
		Component: DistributionLists,
		roles: userRole(),
	},
	{
		path: `/configuracion/tolerancias/:option?/:element_id?`,
		Component: Tolerances,
		roles: userRole(),
	},
];
